import { render, staticRenderFns } from "./ModalLuxUnionEdit.vue?vue&type=template&id=71412bce&scoped=true"
import script from "./ModalLuxUnionEdit.vue?vue&type=script&lang=js"
export * from "./ModalLuxUnionEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalLuxUnionEdit.vue?vue&type=style&index=0&id=71412bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71412bce",
  null
  
)

export default component.exports